var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "grid-view", attrs: { id: "verify-tree-grid" } },
    [
      _c(
        "div",
        { staticClass: "main-content" },
        [
          _c(
            "bank-slip-query",
            {
              ref: "bankSlipRollBack",
              attrs: {
                identify: "bankSlipRollBack",
                "view-source": "bankSlipRollBack",
                "config-module": "1200",
                "is-ar": _vm.searchConditions.applicationStatus,
                oversea: _vm.searchConditions.oversea,
                "is-rollback": true,
                "page-mode": 0,
                "ar-field": "ar",
                "total-type": "revenueAbs",
                "grid-config-module": "1200003"
              },
              scopedSlots: _vm._u([
                {
                  key: "searchAreaHeader",
                  fn: function() {
                    return [
                      _c(
                        "div",
                        {
                          staticClass:
                            "app-main-inner-row  extension-conditions-form",
                          staticStyle: {
                            "padding-bottom": "5px",
                            "margin-top": "-7px"
                          }
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "filters" },
                            [
                              _c(
                                "el-form",
                                {
                                  attrs: {
                                    inline: true,
                                    "label-position": "left"
                                  }
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "el-form-item-wrapper dense-radio-group"
                                    },
                                    [
                                      _c(
                                        "el-form-item",
                                        {
                                          staticClass: "dense-radio-group",
                                          attrs: {
                                            label: _vm.$t(
                                              "WriteOff.writeOffType"
                                            )
                                          }
                                        },
                                        [
                                          _c(
                                            "el-radio-group",
                                            {
                                              model: {
                                                value:
                                                  _vm.searchConditions.oversea,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.searchConditions,
                                                    "oversea",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "searchConditions.oversea"
                                              }
                                            },
                                            [
                                              _c(
                                                "el-radio",
                                                { attrs: { label: -1 } },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "CargoMsg.Cargo_All"
                                                      )
                                                    )
                                                  )
                                                ]
                                              ),
                                              _c(
                                                "el-radio",
                                                { attrs: { label: 0 } },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "CargoMsg.Cargo_Domestic"
                                                      )
                                                    )
                                                  )
                                                ]
                                              ),
                                              _c(
                                                "el-radio",
                                                { attrs: { label: 1 } },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "CargoMsg.Cargo_International"
                                                      )
                                                    )
                                                  )
                                                ]
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-form-item",
                                        {
                                          staticClass: "dense-radio-group",
                                          attrs: {
                                            label: _vm.$t(
                                              "CargoMsg.Cargo_PaymentReceiveMethod"
                                            )
                                          }
                                        },
                                        [
                                          _c(
                                            "el-radio-group",
                                            {
                                              model: {
                                                value:
                                                  _vm.searchConditions
                                                    .applicationStatus,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.searchConditions,
                                                    "applicationStatus",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "searchConditions.applicationStatus"
                                              }
                                            },
                                            [
                                              _c(
                                                "el-radio",
                                                { attrs: { label: -1 } },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "CargoMsg.Cargo_All"
                                                      )
                                                    )
                                                  )
                                                ]
                                              ),
                                              _c(
                                                "el-radio",
                                                { attrs: { label: 1 } },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "CargoMsg.Cargo_Receivable"
                                                      )
                                                    )
                                                  )
                                                ]
                                              ),
                                              _c(
                                                "el-radio",
                                                { attrs: { label: 0 } },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "CargoMsg.Cargo_Dues"
                                                      )
                                                    )
                                                  )
                                                ]
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ]
                      )
                    ]
                  },
                  proxy: true
                }
              ])
            },
            [
              _c(
                "div",
                { attrs: { slot: "operations" }, slot: "operations" },
                [
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.$checkPermission([
                            "button_fmBankSlip_bankSlipRollBack"
                          ]),
                          expression:
                            "$checkPermission(['button_fmBankSlip_bankSlipRollBack'])"
                        }
                      ],
                      attrs: { type: "primary", no: "cancelWriteOff" },
                      on: { click: _vm.cancelWriteOffHandler }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_RevokeClaim")))]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", no: "showDetail" },
                      on: { click: _vm.showDetailHandler }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_ViewDetail")))]
                  ),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.$checkPermission([
                            "button_fmBankSlip_returnApply"
                          ]),
                          expression:
                            "$checkPermission(['button_fmBankSlip_returnApply'])"
                        }
                      ],
                      attrs: { type: "primary", no: "returnApply" },
                      on: { click: _vm.returnApplyHandler }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_ReturnApply")))]
                  ),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.$checkPermission([
                            "button_fmBankSlip_returnApply"
                          ]),
                          expression:
                            "$checkPermission(['button_fmBankSlip_returnApply'])"
                        }
                      ],
                      attrs: { type: "primary", no: "returnApplyCancel" },
                      on: { click: _vm.returnApplyCancelHandler }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_ReturnApplyCancel")))]
                  ),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.$checkPermission([
                            "button_fmBankSlip_returnApplyAudit"
                          ]),
                          expression:
                            "$checkPermission(['button_fmBankSlip_returnApplyAudit'])"
                        }
                      ],
                      attrs: { type: "success", no: "returnApplyAudit" },
                      on: { click: _vm.returnApplyAuditHandler }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_ReturnApplyAudit")))]
                  ),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.$checkPermission([
                            "button_fmBankSlip_returnApplyAudit"
                          ]),
                          expression:
                            "$checkPermission(['button_fmBankSlip_returnApplyAudit'])"
                        }
                      ],
                      attrs: { type: "danger", no: "returnApplyReject" },
                      on: { click: _vm.returnApplyRejectHandler }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_ReturnApplyReject")))]
                  ),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.$checkPermission([
                            "button_fmBankSlip_previewVoucher"
                          ]),
                          expression:
                            "$checkPermission(['button_fmBankSlip_previewVoucher'])"
                        }
                      ],
                      attrs: { type: "primary", no: "previewVoucher" },
                      on: { click: _vm.previewVoucherHandler }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_PreviewVoucher")))]
                  ),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.$checkPermission([
                            "button_fmBankSlip_exportVoucher"
                          ]),
                          expression:
                            "$checkPermission(['button_fmBankSlip_exportVoucher'])"
                        }
                      ],
                      attrs: { type: "primary", no: "exportVoucher" },
                      on: { click: _vm.exportVoucherHandler }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_ExportVoucher")))]
                  )
                ],
                1
              )
            ]
          )
        ],
        1
      ),
      _c("write-off-detail-dialog", {
        attrs: {
          visible: _vm.detailDialog.visible,
          "recheck-button": false,
          params: _vm.detailDialog.params
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.detailDialog, "visible", $event)
          }
        }
      }),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            visible: _vm.returnApplyDialog.show,
            title: _vm.$t("CargoMsg.Cargo_ReturnApply"),
            width: "340px",
            "close-on-click-modal": false,
            "show-close": false
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.returnApplyDialog, "show", $event)
            }
          }
        },
        [
          _c(
            "el-form",
            {
              attrs: {
                inline: true,
                model: _vm.returnApplyDialog.form,
                "label-width": "120px",
                "label-position": "right"
              }
            },
            [
              _c(
                "div",
                { staticClass: "el-form-item-wrapper" },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("CargoMsg.Cargo_RemainingClaimedAmount")
                      }
                    },
                    [
                      _c("el-input-number", {
                        attrs: {
                          disabled: true,
                          no: "amount",
                          precision: 2,
                          "controls-position": "right",
                          controls: false
                        },
                        model: {
                          value: _vm.returnApplyDialog.form.remainingAmount,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.returnApplyDialog.form,
                              "remainingAmount",
                              $$v
                            )
                          },
                          expression: "returnApplyDialog.form.remainingAmount"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "el-form-item-wrapper" },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("CargoMsg.Cargo_RefundAmount") } },
                    [
                      _c("el-input-number", {
                        attrs: {
                          no: "amount",
                          precision: 2,
                          min: 0,
                          max: _vm.returnApplyDialog.form.remainingAmount,
                          "controls-position": "right",
                          controls: false
                        },
                        model: {
                          value: _vm.returnApplyDialog.form.returnApplyAmount,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.returnApplyDialog.form,
                              "returnApplyAmount",
                              $$v
                            )
                          },
                          expression: "returnApplyDialog.form.returnApplyAmount"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ]
          ),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { no: "ok", type: "primary" },
                  on: { click: _vm.doReturnApply }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.ok")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { no: "cancel" },
                  on: {
                    click: function($event) {
                      _vm.returnApplyDialog.show = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm.accountingEntryWindow.visible
        ? _c("accounting-entry-window", {
            attrs: {
              visible: _vm.accountingEntryWindow.visible,
              "is-ext": _vm.accountingEntryWindow.isExt,
              "prefix-data-provider":
                _vm.accountingEntryWindow.prefixDataProvider,
              "account-title-data-provider":
                _vm.accountingEntryWindow.accountTitleDataProvider,
              "mapping-departments":
                _vm.accountingEntryWindow.mappingDepartments,
              "mapping-staffs": _vm.accountingEntryWindow.mappingStaffs,
              voucher: _vm.accountingEntryWindow.rowData,
              index: _vm.accountingEntryWindow.index,
              "account-set": _vm.accountingEntryWindow.accountSet,
              check: false,
              "check-department": false,
              preview: true
            },
            on: {
              close: function() {
                return (_vm.accountingEntryWindow.visible = false)
              },
              updateAudit: function($event) {
                return _vm.$refs.bankSlipRollBack.refreshPageHandler()
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }